module.exports = __webpack_public_path__ + "static/media/no-internet.da1a4146.png";